export const companyConstants = {
  CHANGE_STEP: 'USER_CHANGE_STEP',
  EDIT_PASSWORD: 'EDIT_PASSWORD',
};
